import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { PortfolioContextProvider } from "./context";

import "./index.scss";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <PortfolioContextProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </PortfolioContextProvider>,
);
